<div *ngIf="!!programme || inserting; else loading;">
  <div id="programme-detail-component">
    <div *ngIf="editable; else readonly" class="editable">
      <div class="bigfield">
        <input [(ngModel)]="programme.name" placeholder="Enter the name of a radio programme..."
          title="A programme with topics for discussion." class="h2" style="width: 30em" /></div>
      <div class="expandingfield">
        <label>description: </label>
        <textarea [(ngModel)]="programme.description" style="display:inline-block;" cols="80" rows="2"
          placeholder="Programme long description" title="A long description of the programme."></textarea>
      </div>
      <div class="field" *ngIf="GlobalAdmin()">
        <label>identifier: </label>
        <input [(ngModel)]="programme.short_name" type="text" placeholder="" #short_name id="short_name"
          title="A short name with only lower-case, digits, underscore and minus"
          (ngModelChange)="forceValidShortName($event, 'ngModelChange')" [ngValue]="programme.short_name" />
      </div>
      <div class="field">
        <label>url: </label>
        <input [(ngModel)]="programme.url" class="longer_input" type="text" placeholder="https://... ?"
          title="The URL to a page about this programme." />
      </div>
      <!-- div class="field">
        <label>brand image: </label>
        <input [(ngModel)]="programme.brand_image_id" type="number" placeholder="0" title="The ID of a brand image to be displayed."/>
      </div -->
      <div class="field">
        <label>active: </label>
        <checkbox [(ngModel)]="programme.active"></checkbox><span> &nbsp; </span>
        <span> &nbsp; </span>
        <div *ngIf="CanAdminister()" class="panel">
          <button (click)="save()" class="btn btn-primary">Save</button>
        </div>
      </div>

      <div *ngIf="CanAdminister() && !inserting">
        <img src="/images/cancel.svg" (click)="cancel()" class="editlink">
      </div>
    </div>
    <ng-template #readonly>
      <div class="editable">
        <div class="bigfield"><span class="h2">{{programme.name}}</span></div>
        <div class="field"><label>description: </label>{{programme.description}}</div>
        <div class="field" *ngIf="GlobalAdmin()"><label>identifier: </label>{{programme.short_name}}</div>
        <div class="field"><label>url: </label>{{programme.url}}</div>
        <!-- div class="field"><label>brand image: </label>{{programme.brand_image_id}}</div -->
        <div class="field"><label>active: </label>{{programme.active}}</div>
        <div *ngIf="CanAdminister()">
          <img src="/images/edit.svg" (click)="edit()" class="editlink">
        </div>
      </div>
    </ng-template>
  </div>

  <div *ngIf="programme.response_count > 0">
    <br />
    <h2>{{programme.response_count}} responses</h2>
  </div>
</div>
<ng-template #loading>
  Loading...
</ng-template>